// src/components/DepartmentCard.jsx
import React from "react";
import { motion } from "framer-motion";

const DepartmentCard = ({ department, index, isSelected, onSelect }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "0px 0px -100px 0px" }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className={`department-card ${isSelected ? "selected" : ""} cursor-pointer`}
      onClick={() => onSelect(department)}
    >
      {/* Card Front */}
      <div className="card-front">
        <div className="card-image">
          <img
            src={department.image}
            alt={department.title}
            className="w-full h-48 object-cover rounded-t-xl"
          />
        </div>
        <h3 className="text-lg font-semibold mt-2 px-2">{department.title}</h3>
      </div>

      {/* Card Details */}
      {isSelected && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
          className="card-details p-4 bg-gray-50 rounded-b-xl"
        >
          <p className="text-gray-700 text-sm">{department.description}</p>
        </motion.div>
      )}
    </motion.div>
  );
};

export default DepartmentCard;
